import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, ReduxFormHiddenInput, Button } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalDeclareDelete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onDeleteDeclare, onToggleModal, selectDeclareNo, declareDetail } = this.props;

    if (!selectDeclareNo || !declareDetail.get(String(selectDeclareNo))) {
      return null;
    }

    const data = declareDetail.get(String(selectDeclareNo));

    const declareDeleteComponent = (
      <List bulleted className={cx('template-detail-list')}>
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>No</div>
          {data.declareNo}
        </List.Item>
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>
            {defineMessages(formatMessage({ id: 'ModalDeclare_5', defaultMessage: '훈련명' }))}
          </div>
          {data.examName}
        </List.Item>
        {data.isNis !== 1 && (
          <List.Item className={cx('template-detail-item')}>
            <div className={cx('template-detail-item-title')}>
              {defineMessages(formatMessage({ id: 'ModalDeclare_6', defaultMessage: '신고 제목' }))}
            </div>
            {data.subject}
          </List.Item>
        )}
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>
            {defineMessages(formatMessage({ id: 'ModalDeclare_7', defaultMessage: '신고 일시' }))}
          </div>
          {common.timeFormatFromUTCEpoch(data.regEpoch)}
        </List.Item>
      </List>
    );

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-tagDelete-area', 'common-content')}
        visible={visible}
        header={defineMessages(formatMessage({ id: 'ModalDeclareDelete_1', defaultMessage: '신고 정보 삭제' }))}
        onToggleModal={onToggleModal}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalDeclare_1', defaultMessage: '취 소' }))}
            </Button>
            <Button
              className={cx('gray-button')}
              disabled={isClicked}
              loading={isClicked}
              onClick={e => {
                e.stopPropagation();
                onDeleteDeclare(selectDeclareNo);
              }}>
              {defineMessages(formatMessage({ id: 'ModalDeclare_2', defaultMessage: '삭 제' }))}
            </Button>
          </div>
        }>
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ModalDeclare_3',
              defaultMessage: '삭제한 신고 정보는 복구할 수 없습니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ModalDeclare_4',
              defaultMessage: '다음 정보를 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>{declareDeleteComponent}</div>
        </Message>
      </ModalTemplate>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      // tagNo: !!props.selectedTag && props.selectedTag.get('tagNo'),
      // tagName: !!props.selectedTag && props.selectedTag.get('tagName')
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formTagDelete', enableReinitialize: true })(injectIntl(ModalDeclareDelete))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalDeclareDelete.js